// ─────────────────────────────────────────────
//  AmountInput.jsx
//  Entrada del monto de consumo
//
//  RN migration:
//  • <div> → <View>
//  • <label> → <Text> (accessibility via accessibilityLabel)
//  • <input> → <TextInput keyboardType="decimal-pad" />
// ─────────────────────────────────────────────

import React, { useRef, useEffect } from 'react';
import styles from './AmountInput.module.css';
// import { formatCurrency } from '../utils/format';

/* export default function AmountInput({ hasAmount, value, onChange }) {
	const inputRef = useRef(null);

	return (
		<section className={styles.card} aria-label="Monto del consumo">
			<p className={styles.label}>
				{value ? 'Consumo' : ''}
			</p>

			<div className={styles.inputWrap} onClick={() => inputRef.current?.focus()}>
				<span className={styles.currency} aria-hidden="true">$</span>
				<input
					ref={inputRef}
					className={styles.input}
					type="number"
					min="0"
					step="0.01"
					value={value}
					placeholder="Ingresa tu consumo"
					inputMode="decimal"
					aria-label="Monto de consumo en dólares"
					onChange={(e) => onChange(e.target.value)}
				/>
			</div>

		</section>
	);
} */



export default function AmountInput({ value, onChange, onReset }) {
	const inputRef = useRef(null);


	// ① Focus automático al montar (web + PWA)
	useEffect(() => {
		const focusInput = () => {
			inputRef.current?.focus({ preventScroll: true });
		};

		focusInput();
		requestAnimationFrame(focusInput);
		const timer = window.setTimeout(focusInput, 100);

		return () => window.clearTimeout(timer);
	}, []);


	const handleReset = () => {
		onReset?.();
		inputRef.current?.focus();
	};


	// ② Validación del valor antes de propagar al padre
	const handleChange = (e) => {
		const raw = e.target.value;

		// Bloquear cualquier carácter que no sea dígito o punto
		const sanitized = raw.replace(/[^0-9.]/g, '');

		// Solo un punto decimal
		const parts = sanitized.split('.');
		if (parts.length > 2) return; // ya tiene más de un punto → ignorar

		// Máximo 2 dígitos decimales
		if (parts[1] !== undefined && parts[1].length > 2) return;

		// ③ Máximo 99,999,999.99
		if (parseFloat(sanitized) > 99999999.99) return;

		onChange(sanitized);
	};

	return (
		<section className={styles.card} aria-label="Monto del consumo">

			{/* <p className={styles.label}>
				{value ? 'Consumo' : ''}
			</p> */}

			{value ? <button
				type="button"
				className={`${styles.resetBtn} ${styles.label}`}
				onClick={handleReset}
				aria-label="Reiniciar calculadora"
			>
				<span>↺</span> Reiniciar
			</button>
			 : ''}		
			

			<div className={styles.inputWrap} onClick={() => inputRef.current?.focus()}>
				<span className={styles.currency} aria-hidden="true">$</span>
				<input
					ref={inputRef}
					className={styles.input}
					type="text"
					inputMode="decimal"
					autoFocus
					value={value}
					placeholder="Ingresa tu consumo"
					aria-label="Monto de consumo en dólares"
					onChange={handleChange}
				/>
			</div>
		</section>
	);
}